import React, { useEffect, useState } from "react";
import { ShieldCheck, FileText } from "lucide-react";
import { Page, Card, Pill } from "../components/UI";
import api from "../lib/api";

const ACTION_COLORS = {
  create: "primary", update: "warn", delete: "danger",
  view: "default", login: "success", logout: "default",
  generate: "primary", submit: "primary", appeal: "warn",
  sign: "success", withdraw: "danger", enable: "success", disable: "danger",
  rollback: "danger", migrate: "primary", upload: "primary",
};

export default function AuditLog() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    api.get("/audit/log").then(({ data }) => setEntries(data)).finally(() => setLoading(false));
  }, []);

  const filtered = entries.filter(e =>
    `${e.action} ${e.resource} ${e.resource_id}`.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <Page title="Audit Log" subtitle="HIPAA-compliant immutable record of every action you've taken.">
      <Card delay={0.05} className="mb-4">
        <input
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          placeholder="Filter by action, resource, or ID…"
          className="w-full px-4 py-2.5 rounded-xl outline-none text-sm"
          style={{ background: "var(--mf-muted)" }}
          data-testid="audit-filter"
        />
      </Card>

      {loading ? <div className="mf-skeleton h-48"></div> : (
        <Card>
          <div className="flex items-center gap-2 mb-4">
            <ShieldCheck className="w-5 h-5" style={{ color: "var(--mf-secondary)" }} />
            <div className="text-sm" style={{ color: "var(--mf-text-muted)" }}>{filtered.length} entries · 7-year retention</div>
          </div>
          {filtered.length === 0 ? (
            <div className="text-sm py-6 text-center" style={{ color: "var(--mf-text-muted)" }}>No audit entries yet.</div>
          ) : (
            <div className="space-y-1.5 max-h-[600px] overflow-y-auto">
              {filtered.map((e) => (
                <div key={e.id} className="p-3 rounded-xl flex items-center gap-3 text-sm" style={{ background: "var(--mf-muted)" }} data-testid={`audit-${e.id}`}>
                  <Pill variant={ACTION_COLORS[e.action] || "default"}>{e.action}</Pill>
                  <span className="font-medium">{e.resource}</span>
                  {e.resource_id && <span className="text-xs font-mono opacity-60 truncate max-w-[120px]">{e.resource_id.slice(0, 8)}</span>}
                  <span className="ml-auto text-xs" style={{ color: "var(--mf-text-muted)" }}>{new Date(e.timestamp).toLocaleString()}</span>
                </div>
              ))}
            </div>
          )}
        </Card>
      )}
    </Page>
  );
}
